// api/live.js
import http from '@/utils/http'

// 统一参数处理层
const getBaseParams = () => {
  const routeParams = window.location.search
    ? Object.fromEntries(new URLSearchParams(window.location.search))
    : {}

  return {
    room_id: routeParams.room_id || '',
    source: 1
  }

}

// 业务请求封装
export const messageStatus = async (ws_id, type, status, id) => {
  try {
    const response = await http.post('/live/manage', {
      ...getBaseParams(),
      type,
      function: status,
      req_id: id,
      ws_id: ws_id || '',
    })

    return response.data
  } catch (error) {
    console.log(error)
    throw error
  }
}

// export const setNotice = async () => {
//   try {
//     const response = await http.post('/live/mainNotice', {
//       room_id:getBaseParams().room_id,
//       ws_id: getBaseParams().ws_id,
//     })
//     return response.data
//   } catch (error) {
//    console.log(error)
//     throw error
//   }
// }